import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useTranslation } from "react-i18next";
import congratsImage from "asset/img/congrats-achivement.png";
import { FCM_CONGRATS_EVENT } from "utils/firebase-message";
import useStyles from "./styles";

const MY_WORK_BADGES_TAB = "badges";

const CongratsAchievementModal = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translate = useTranslation().t;
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handler = (event: Event) => {
      const { message: congratsMessage } = (event as CustomEvent<{
        message: string;
      }>).detail;
      console.log("congratsMessage", congratsMessage);
      if (congratsMessage) {
        setMessage(congratsMessage);
        setOpen(true);
      }
    };

    window.addEventListener(FCM_CONGRATS_EVENT, handler);
    return () => window.removeEventListener(FCM_CONGRATS_EVENT, handler);
  }, []);

  const handleClose = () => setOpen(false);

  const handleView = () => {
    setOpen(false);
    dispatch(push(`/my-work?tab=${MY_WORK_BADGES_TAB}`));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      classes={{ paper: classes.dialogPaper }}
      maxWidth={false}
    >
      <IconButton
        className={classes.closeButton}
        onClick={handleClose}
        aria-label="close"
      >
        <CloseIcon fontSize="small" />
      </IconButton>

      <div className={classes.content}>
        <img
          src={congratsImage}
          alt="achievement"
          className={classes.image}
        />
        <p className={classes.title}>{translate("CONGRATULATIONS")}</p>
        <p className={classes.message}>{message}</p>
      </div>

      <div className={classes.actions}>
        <Button
          className={`${classes.actionButton} ${classes.closeBtn}`}
          onClick={handleClose}
        >
          {translate("CLOSE")}
        </Button>
        <Button
          className={`${classes.actionButton} ${classes.viewBtn}`}
          onClick={handleView}
          variant="contained"
          color="primary"
        >
          {translate("VIEW")}
        </Button>
      </div>
    </Dialog>
  );
});

export default CongratsAchievementModal;
